// "Przykładowe raporty" — a curated set of pre-seeded reports offered on the
// empty homepage so any doctor can open a real report without typing.
// They ride the normal search route (goToSearch → /:query), so opening one
// behaves exactly like any other library-backed report; there is no static
// demo path. The set (decision 2026-08-18) spans the pilot specialties —
// endocrinology (cabergoline, prednisone, DHEA), diabetology (semaglutide),
// antiemetics (thiethylperazine), anti-infectives (metronidazole,
// azithromycin), analgesia (aspirin), rheumatology (Plaquenil), and OB/GYN
// (the relugolix/estradiol/norethisterone combination) — so every pilot
// doctor sees at least one drug from their own practice. Every entry must
// exist in the production library — these are shop-window examples, not
// on-demand generations.
//
// Visibility (decision 2026-08-15): the chips are PERMANENT on the empty
// homepage. The old rule that hid them after 3 distinct reports is gone —
// reference tools keep static homes, and the pilot doctors need the entry
// points on every return visit, not only on day one.
//
// Query mix: the chips deliberately mix an ATC code, Latin INNs, a brand
// name, and a combination so a new user sees the different search forms the
// app accepts. The brand chip (Plaquenil) and the Semaglutidum spelling are
// not first-chance alias hits; they converge on the seeded report through
// the backend identity path (canonical name / ATC alias) on first open.
// Every other chip is a first-chance library hit.
export const STARTER_REPORTS = [
  { query: "G02CB03", label: "Cabergolinum", atc: "G02CB03" },
  { query: "Semaglutidum", label: "Semaglutidum", atc: "A10BJ06" },
  { query: "Thiethylperazinum", label: "Thiethylperazinum", atc: "R06AD03" },
  { query: "Metronidazolum", label: "Metronidazolum", atc: "G01AF01" },
  { query: "Prednisonum", label: "Prednisonum", atc: "H02AB07" },
  {
    query: "Dehydroepiandrosteronum",
    label: "Dehydroepiandrosteronum",
    atc: "G03XX01",
  },
  {
    query: "Acidum acetylsalicylicum",
    label: "Acidum acetylsalicylicum",
    atc: "B01AC06",
  },
  { query: "Plaquenil", label: "Plaquenil", atc: "P01BA02" },
  { query: "Azithromycinum", label: "Azithromycinum", atc: "J01FA10" },
  {
    query: "Relugolixum + Estradiolum + Norethisteroni acetas",
    label: "Relugolixum + Estradiolum + Norethisteroni acetas",
    atc: "H01CC54",
  },
] as const;
